import keys from './keys';
import useApiQuery from '../useApiQuery';

const useGetCustomer = ({ disabled } = {}) => {
  const query = useApiQuery({
    requestUrl: '/customer',
    disabled,
    queryKey: keys.customer,
  });

  return {
    customer: query.data,
    customerError: query.error,
    isCustomerFetchError: query.isError,
    isCustomerFetchSuccess: query.isSuccess,
    isCustomerFetching: query.isFetching,
    isCustomerLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetCustomer;
